import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SubHead from './SubHead/SubHead';
import NavHead from './SubHead/NavHead';
import BodyText from './BodyText/BodyText';
import AmazonBodyText from './BodyText/AmazonBodyText';
import CallOut from './CallOut/CallOut';
import PullQuote from './PullQuote/PullQuote';
import ImageModule from './ImageModule/ImageModule';
import ProductModule from './ImageModule/ProductModule';
import AmazonProductModule from './ImageModule/AmazonProductModule';
import ContentModule from './ImageModule/ContentModule';
import EmbedModule from './EmbedModule/EmbedModule';
import FAQ from './FAQ/FAQ';
import WowBox from './WowBox/WowBox';
import RecommendedArticles from './RecommendedArticles/RecommendedArticles';
import Video from './Video/Video';
import VideoEmbed from './EmbedModule/VideoEmbed';
import RelatedModule from './RelatedModule/RelatedModule';
import RelatedTags from './RelatedTags/RelatedTags';
import MultipleImages from './ImageModule/MultipleImages';
import ShoppableGrid from './ArticleShoppable/ShoppableGrid';
import ArticleSlideshow from './ArticleSlideshow/ArticleSlideshow';
import TaggedShoppable from './ArticleShoppable/TaggedShoppable';
import ContentHeader from './ContentHeader/ContentHeader';
import Quiz from './Quiz/Quiz';
import Recipe from './RecipeModule/Recipe';
import RecipeBasic from './RecipeModule/RecipeBasic';
import AmazonRSSModule from '../AmazonRSSModule';
import ProductSummary from './ProductSummary/ProductSummary';
import ShoppableStorefront from './ShoppableStorefront/ShoppableStorefront';
import TableOfContents from './TableOfContents/TableOfContents';
import ImageCarousel from './Carousel/ImageCarousel';
import EditorsAndExperts from '../../Page/PageModules/EditorsAndExperts/EditorsAndExperts';
import ArticleGrid from '../../Page/PageModules/ArticleGrid/ArticleGrid';
import ArticlePicker from './ArticlePicker/ArticlePicker';
import Ad from '../../Ad';
import withArticleTracking from '../../common/withArticleTracking';
import { isValid, scrollToTopOf } from '../../../utils';

const componentMap = {
  'sub-head': SubHead,
  'nav-head': NavHead,
  'body-text': BodyText,
  'paragraph': BodyText,
  'call-out': CallOut,
  'amazon-body-text': AmazonBodyText,
  'large-image': ImageModule,
  'full-width-image': ImageModule,
  'teaser-image': ImageModule,
  'multi-image-row': MultipleImages,
  'large-product': ProductModule,
  'amazon-product-module': AmazonProductModule,
  'large-content': ContentModule,
  'pull-quote': PullQuote,
  'drop-case-text': BodyText,
  'social-embed': EmbedModule,
  'video-embed': VideoEmbed,
  'video': Video,
  'shoppable-grid': ShoppableGrid,
  'slideshow': ArticleSlideshow,
  'recipe': Recipe,
  'recipe-basic': RecipeBasic,
  'quiz': Quiz,
  'ad': Ad,
  'related-stories': RelatedModule,
  'related-tags': RelatedTags,
  'amazon-rss-module': AmazonRSSModule,
  'tagged-shoppable': TaggedShoppable,
  'content-header': ContentHeader,
  'large-product-summary': ProductSummary,
  'shoppable-storefront': ShoppableStorefront,
  'faq': FAQ,
  'wow-box': WowBox,
  'recommended-articles': RecommendedArticles,
  'affiliate-table-of-contents': TableOfContents,
  'carousel': ImageCarousel,
  'pages-editors-and-experts': EditorsAndExperts,
  'article-grid-1x4': ArticleGrid,
  'article-pickers-module': ArticlePicker,
  'article-pickers': ArticlePicker,
};

export default class ArticleModules extends PureComponent {
  render() {
    const {
      id,
      headline,
      guideBodyTextModule,
      modules = [],
      isMobile,
      fullUrl,
      slug,
      isClient,
      hasAds,
      category,
      pubData,
      name,
      authorImg,
      link,
      sponsorship,
      display,
      tags,
      secondAuthorName,
      secondAuthorText,
      secondAuthorUrl,
      articleLayout,
      navHeads,
      seo,
      settings,
      adType,
      isAffiliate,
      productSummary,
      showHero,
    } = this.props;
    // if articleLayout is Guide, add module we removed in line 297 of transformArticle.js back into the modules array for the when view is Desktop
    let modulesCopy = [...modules];
    if (isValid(guideBodyTextModule)) {
      modulesCopy.unshift(guideBodyTextModule);
    }
    const transformModules = ((articleLayout === 'Guide' && !isMobile) || (articleLayout === 'Shoppable Storefront' && !isMobile) || (articleLayout === 'Shoppable Storefront' && !showHero)) ? modulesCopy : modules;
    const isContentHub = settings.articleLayout === 'Content Hub';
    const articleModules = transformModules.filter(module => module.data && (isContentHub || module.data.videoEmbedLayout !== 'wide'));
    let relatedTagsIndex = 0;

    const renderedModules = articleModules.map((module, i) => {
      let moduleType = (isValid(module.type)) ? module.type : null;
      moduleType = (moduleType === 'paragraph') ? 'body-text' : moduleType;
      if (!isValid(componentMap[moduleType])) {
        return null;
      }
      if (moduleType === 'social-image-carousel') {
        return null;
      }
      const ItemComponent = componentMap[moduleType];
      // Related Tags Ads need to have a unique identifier for placementNames
      if (moduleType === 'related-tags') {
        relatedTagsIndex++;
      }
      /*
        Certain modules wrap trackable elements (ex. anchor tags rendered as part of BodyText copy
        or anchor tags inside ImageModule).
      */

      const trackableModules = [
        'body-text',
        'paragraph',
        'amazon-body-text',
        'call-out',
        'large-image',
        'full-width-image',
        'article-shoppable',
        'article-slideshow',
        'multi-image-row',
        'drop-case-text',
        'amazon-rss-module',
        'large-product',
        'amazon-product-module',
        'social-embed',
        'video-embed',
        'video ',
        'shoppable-grid',
        'large-content',
        'related-stories',
        'related-tags',
        'recipe',
        'recipe-basic',
        'quiz',
        'shoppable-storefront',
        'faq',
        'wow-box',
        'recommended-articles',
        'large-product-summary',
        'affiliate-table-of-contents',
        'carousel',
        // 'article-grid-1x4',
        'pages-editors-and-experts',
        'article-pickers',
        'article-pickers-module',
      ];

      if (trackableModules.includes(moduleType)) {
        const TrackedItemComponent = withArticleTracking(
          ItemComponent,
        );

        // className and moduleName have same values for now but may change in the future.
        return (
          <TrackedItemComponent
            key={i}
            id={id} 
            data={module.data}
            header={module.header}
            blurb={module.blurb}
            isMobile={isMobile}
            isClient={isClient}
            wrapperClassName='module'
            className={moduleType}
            fullUrl={fullUrl}
            moduleName={moduleType}
            articleLayout={settings.articleLayout}
            settings={settings} 
            isAffiliate={isAffiliate}
            seo={seo}
            articleType={sponsorship.articleType} 
            sponsorship={sponsorship}
            id={id} 
            slug={slug}
            hasAds={hasAds} 
            category={category}
            adType={adType}
            productSummary={productSummary}
            isContentHub={isContentHub}/>
        );
      }
      return (
        <div className='module' key={i}>
          <ItemComponent 
            id={id} 
            headline={headline}
            data={module.data}
            type={module.type}
            isMobile={isMobile}
            className={moduleType}
            fullUrl={fullUrl} 
            slug={slug}
            isClient={isClient} 
            hasAds={hasAds} 
            relatedTagsIndex={relatedTagsIndex}
            category={category}
            pubData={pubData}
            name={name}
            authorImg={authorImg}
            sponsorship={sponsorship}
            link={link}
            display={display}
            tags={tags}
            secondAuthorName={secondAuthorName}
            secondAuthorText={secondAuthorText}
            secondAuthorUrl={secondAuthorUrl}
            articleLayout={settings.articleLayout}
            navHeads={navHeads}
            seo={seo}
            settings={settings}
            adType={adType}
            isAffiliate={isAffiliate}
            articleType={articleLayout.type}
            productSummary={productSummary}
            isContentHub={isContentHub}/>
        </div>
      );
    });

    return renderedModules;
  }
}
